

// 判断环境
const isProd = process.env.NODE_ENV === 'production';

// https://m.huishouka.com.cn
export const BASE_API = 'https://m.jinhuixinxi.cn';
// export const BASE_API = 'http://localhost:8080';
export const CONFIG = {
  // 请求超时时间
  timeout: 60000,
};

export default {
  BASE_API,
  CONFIG
};
